import React from "react";

export default function Status() {
  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        color: "#2d3e50",
      }}
    >
      <h1 style={{ fontSize: "28px", marginBottom: "12px" }}>
        Order Status
      </h1>

      <p style={{ fontSize: "16px", opacity: 0.75, maxWidth: "500px", margin: "0 auto" }}>
        This page will show detailed order information.
        (Functionality will be added soon.)
      </p>
    </div>
  );
}
